<!-- No max-height/overflow/side padding here: mat-bottom-sheet-container already caps at 80vh,
     scrolls, and pads 8px 16px. A second scroller inside it showed two scrollbars on Windows. -->
<div class="pb-6">

  <!-- Sticky so close stays reachable on long content. Sticky offsets from the container's
       content box, so -top-2/-mt-2 cover its 8px top padding instead of letting
       content show through above the header. -->
  <div class="sticky -top-2 z-10 -mt-2 pt-4 bg-white">
    <div class="flex justify-center pb-1">
      <div class="w-10 h-1 rounded-full bg-gray-300"></div>
    </div>

    <div class="flex justify-end -mt-1 -mb-1">
      <button type="button" mat-icon-button aria-label="Close" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <app-public-profile-card [corperSlug]="data.corperSlug"></app-public-profile-card>

</div>
